/* ============================================================
   ILS - Live "N.000+ orders delivered" patcher (TASK-2038).

   Replaces hardcoded 14.000+ figures across the site with a
   live value derived from the latest Shopify order_number:
     count = floor((order_number - 1000) / 1000) * 1000
   Returned by GET {apiBase}/api/orders/count and rendered
   with EU-thousands-dot formatting per brand book (14.000+).

   Slot elements — any element with [data-ils-orders-count-live].
   The element's [data-tpl] attribute is a template string:

     {formatted}   pre-formatted "14.000+" from the backend
     {count}       raw integer 14000 (unformatted)
     {countfmt}    integer formatted with EU dots: "14.000"

   Default template when [data-tpl] is missing: "{formatted}".

   Config source: window.ILS_REVIEWS_HOME.apiBase (already
   emitted by custom-reviews-home section on the home page and
   the PDP summary bootstrap; same wiring as the store-rating
   patcher, so nothing new to plumb).

   On fetch error / empty payload the Liquid fallback stays.
   ============================================================ */
(function () {
  'use strict';

  function formatThousandsDot(n) {
    var v = parseInt(n, 10);
    if (!isFinite(v)) return '';
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function applyTemplate(tpl, values) {
    if (typeof tpl !== 'string' || !tpl) return '';
    return tpl
      .replace(/\{formatted\}/g, values.formatted || '')
      .replace(/\{countfmt\}/g, values.countfmt || '')
      .replace(/\{count\}/g, values.count || '');
  }

  function paintAll(values) {
    var slots = document.querySelectorAll('[data-ils-orders-count-live]');
    if (!slots.length) return;
    slots.forEach(function (el) {
      var tpl = el.getAttribute('data-tpl') || '{formatted}';
      var out = applyTemplate(tpl, values);
      if (out) el.textContent = out;
    });
  }

  function init() {
    var slots = document.querySelectorAll('[data-ils-orders-count-live]');
    if (!slots.length) return;

    var cfg = window.ILS_REVIEWS_HOME || {};
    var apiBase = (typeof cfg.apiBase === 'string' && cfg.apiBase)
      ? cfg.apiBase.replace(/\/+$/, '') : '';
    if (!apiBase) {
      if (window.console && console.warn) {
        console.warn('[ils-orders-count-live] no apiBase configured - keeping Liquid fallback.');
      }
      return;
    }

    fetch(apiBase + '/api/orders/count', { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;
        var raw = parseInt(data.orders_delivered, 10);
        if (!isFinite(raw) || raw < 0) return;
        var formatted = (typeof data.formatted === 'string' && data.formatted)
          ? data.formatted
          : (formatThousandsDot(raw) + '+');
        paintAll({
          formatted: formatted,
          count: String(raw),
          countfmt: formatThousandsDot(raw),
        });
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ils-orders-count-live] fetch failed - keeping Liquid fallback.', err);
        }
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
